import { Link } from 'react-router-dom'
import { logo } from '@clofo/ui/images'
import { Trans, useTranslation } from '@clofo/i18n'
import { usePageTitle } from '@clofo/ui/hooks'
import { Button } from '@clofo/ui/button'

/**
 * Landing page for invalid or expired password-reset links. The reset page redirects here when the
 * token check fails; the only way forward is requesting a fresh reset email.
 */
export const PasswordTokenErrorPage = () => {
  const { t } = useTranslation()
  usePageTitle(t('login.reset.tokenErrorTitle'))

  return (
    <main className='flex flex-col bg-background items-center justify-center'>
      <img src={logo} alt='Closing Folders' className='my-13 h-15' />
      <div className='w-full max-w-xl px-4'>
        <h1 className='text-xl font-semibold mb-6'>{t('login.reset.tokenErrorTitle')}</h1>
        <p className='leading-relaxed'>
          <Trans
            t={t}
            i18nKey='login.reset.tokenErrorDescription'
            components={{ a: <a className='text-primary font-medium hover:underline' /> }}
          />
        </p>
        <hr className='my-6 border-secondary' />
        <Button asChild size='lg' className='w-fit'>
          <Link to='/passwords/forgot'>{t('login.reset.requestNewPassword')}</Link>
        </Button>
      </div>
    </main>
  )
}
